const getExternalClientId = config => {
  return config?.vInitRequest?.externalClientId ?? config?.merchantConfig?.externalClientId ?? null;
};

export default getExternalClientId;
